import groveScout from "../assets/greenwood-tiers-labeled-v3/grove-scout.jpg";
import veilRanger from "../assets/greenwood-tiers-labeled-v3/veil-ranger.jpg";
import thornWarden from "../assets/greenwood-tiers-labeled-v3/thorn-warden.jpg";
import elderwoodSentinel from "../assets/greenwood-tiers-labeled-v3/elderwood-sentinel.jpg";
import verdantArchon from "../assets/greenwood-tiers-labeled-v3/verdant-archon.jpg";
import sylvanSovereign from "../assets/greenwood-tiers-labeled-v3/sylvan-sovereign.jpg";

export const tierIdentities = [
  { tier: 10, name: "Grove Scout", image: groveScout },
  { tier: 100, name: "Veil Ranger", image: veilRanger },
  { tier: 500, name: "Thorn Warden", image: thornWarden },
  { tier: 1_000, name: "Elderwood Sentinel", image: elderwoodSentinel },
  { tier: 2_000, name: "Verdant Archon", image: verdantArchon },
  { tier: 5_000, name: "Sylvan Sovereign", image: sylvanSovereign },
];

export function tierName(tier: number): string {
  if (tier === 0) return "SOCIAL QUEST";
  return tierIdentities.find(identity => identity.tier === tier)?.name ?? "RELIC";
}

export function TierPortrait({ tier, className = "" }: { tier: number; className?: string }) {
  const identity = tierIdentities.find(candidate => candidate.tier === tier);
  if (!identity) return null;
  return <img className={`tier-portrait ${className}`} src={identity.image} alt="" aria-hidden="true"
    width={640} height={640} decoding="async" />;
}
